import { z } from "zod";

import { questionnaireSchema } from "./questionnaire.type";
import { questionnaireResponseSchema } from "./questionnaire-response.type";

export const questionnaireWithResponsesSchema = questionnaireSchema.extend({
  responses: z.array(questionnaireResponseSchema),
});

export type QuestionnaireWithResponses = z.infer<
  typeof questionnaireWithResponsesSchema
>;
